import mutations from "./helpers/mutations";

const CLOSABLE_ATTR = "data-closable";
const CLOSER_SELECTOR = "[role=presentation]";
const EVENT = "click";
const SELECTOR = "[data-component=notification]";

function onclick(e) {
  const { target } = e;
  const notification = target.closest(SELECTOR);

  target.removeEventListener(EVENT, onclick);
  notification.parentNode.removeChild(notification);
}

function processNotification(notification) {
  if (notification.hasAttribute(CLOSABLE_ATTR)) {
    notification.querySelector(CLOSER_SELECTOR).addEventListener(EVENT, onclick);
  }
}

function init() {
  document.querySelectorAll(SELECTOR).forEach(processNotification);
}

document.addEventListener("DOMContentLoaded", init);

mutations.add(SELECTOR, processNotification);



// WEBPACK FOOTER //
// ./shared/notifications.js